import cn from "classnames"

import { Text, Box } from "ui-kit/components-branded/index"
import { Discount } from "components"
import { useBookingContext } from "modules/Booking/BookingContext"
import { useGetServicePrice } from "modules/Booking/common/hooks"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import style from "modules/Booking/FormPage/components/SingleSession/style.module.scss"

export function SingleSession() {
    const [{ psy, currency, sessionType, selectedDiscount }, { changeSessionType }] =
        useBookingContext()
    const [price, discountPrice] = useGetServicePrice()

    return (
        <Box
            className={cn(style.container, {
                [style.isActive]: sessionType !== SESSION_TYPE.DEPOSIT,
            })}
            onClick={() => changeSessionType(SESSION_TYPE.DEFAULT)}
        >
            <div className={style.title}>1 сессия</div>
            <Text className={style.text}>
                <Discount
                    psy={psy}
                    singleServicePrice={selectedDiscount ? price : discountPrice}
                    showDiscountInBooking
                    showStrikeOut={false}
                    className="is-lowercase"
                    currency={currency}
                />
                &nbsp;за сессию
            </Text>
        </Box>
    )
}
